import { ExternalLink } from "lucide-react";

const STORE_URL = "https://fyndanu.se/butik/e435da0b-10d0-46fa-a389-702295c89840";
const SELL_URL = "https://fyndanu.se/salj-husbil";

type Variant = {
  eyebrow: string;
  text: string;
  cta: string;
  href: string;
};

/** Väljer en kontextuell Fyndanu-hänvisning utifrån trådens ämne. */
function pickVariant(context: string): Variant {
  const c = context.toLowerCase();
  if (/(sälj|sälja|byta in|inbyte|värdera|värdering|annonsera)/.test(c)) {
    return {
      eyebrow: "Sälja själv?",
      text: "Vi driver marknadsplatsen Fyndanu tillsammans med branschen — där lägger du upp husbilen eller husvagnen gratis och når köpare i hela Sverige.",
      cta: "Lägg upp din annons",
      href: SELL_URL,
    };
  }
  if (/(husvagn|vagn|kåk)/.test(c)) {
    return {
      eyebrow: "Letar du husvagn?",
      text: "Våra husvagnar ligger även på Fyndanu med bilder, mått och vikter — alla fukttestade och gasoltestade vid leverans.",
      cta: "Se våra husvagnar på Fyndanu",
      href: STORE_URL,
    };
  }
  if (/(fukt|gasol|el |värmare|vatten|service|verkstad|reservdel)/.test(c)) {
    return {
      eyebrow: "Trygg begagnat­affär",
      text: "Alla fordon vi lägger ut på Fyndanu är fukttestade och gasoltestade innan leverans — du ser protokollet innan du köper.",
      cta: "Se fordonen på Fyndanu",
      href: STORE_URL,
    };
  }
  return {
    eyebrow: "På Fyndanu just nu",
    text: "Vårt lager finns även på marknadsplatsen Fyndanu — husbilar och husvagnar med kompletta uppgifter, fukttest och gasoltest.",
    cta: "Se vår butik på Fyndanu",
    href: STORE_URL,
  };
}

export function FyndanuForumCard({
  context = "",
  className,
}: {
  context?: string;
  className?: string;
}) {
  const v = pickVariant(context);
  return (
    <div className={`rounded-2xl border border-border bg-card p-5 ${className ?? ""}`}>
      <p className="eyebrow">{v.eyebrow}</p>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{v.text}</p>
      <a
        href={v.href}
        target="_blank"
        rel="noopener"
        className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-accent/40 bg-accent/10 px-4 py-2.5 text-sm font-semibold text-accent transition hover:bg-accent/20"
      >
        {v.cta}
        <ExternalLink size={14} />
      </a>
    </div>
  );
}
